import type { I18N_CONF } from '@funkey/locales/config';

export namespace StoryblokUtils {
    export const LOCALES = ['default', 'nl', 'fr-be', 'en'] as const;
    export type Locale = (typeof LOCALES)[number];
    export namespace Locale {
        export function fromFunkeyLocale(locale: I18N_CONF.Locale): StoryblokUtils.Locale {
            switch (locale) {
                case 'nl-BE':
                    return 'default';
                case 'nl-NL':
                    return 'nl';
                case 'fr-BE':
                case 'fr-LU':
                    return 'fr-be';
                case 'en-BE':
                case 'en-NL':
                case 'en-LU':
                    return 'en';
                default:
                    locale satisfies never;
                    throw new Error('UNREACHABLE');
            }
        }

        export function toFunkeyLocales(sbLocale: StoryblokUtils.Locale): Array<I18N_CONF.Locale> {
            switch (sbLocale) {
                case 'default':
                    return ['nl-BE'];
                case 'nl':
                    return ['nl-NL'];
                case 'fr-be':
                    return ['fr-BE', 'fr-LU'];
                case 'en':
                    return ['en-BE', 'en-NL', 'en-LU'];
                default:
                    sbLocale satisfies never;
                    throw new Error('UNREACHABLE');
            }
        }
    }
}
